/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiCornerOutUpRightIcon24Solid = forwardRef('ArrowUiCornerOutUpRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.475 2a3.501 3.501 0 0 0 2.037 4.54l-3.747 3.747a3.5 3.5 0 1 0 4.95 4.95l3.747-3.747A3.501 3.501 0 0 0 22 13.53V17.5a4.5 4.5 0 0 1-4.5 4.5h-11A4.5 4.5 0 0 1 2 17.5v-11A4.5 4.5 0 0 1 6.5 2h3.975Z" }),
        React.createElement("path", { d: "M19.49 6.28v3.982a1.25 1.25 0 0 0 2.5 0v-6.5a1.75 1.75 0 0 0-1.75-1.75h-6.5a1.25 1.25 0 0 0 0 2.5h3.982l-7.366 7.366a1.25 1.25 0 1 0 1.768 1.768L19.49 6.28Z" })));
});
